import "./IconIncome.scss";
import { ReactComponent as IncomeIcon } from "./svg/income.svg";

type Props = {
  color?: "black" | "blue";
};

export const IconIncome = (props: Props) => {
  const { color = "black" } = props;
  return (
    <span className={`IconIncome IconIncome${color}`}>
      <IncomeIcon />
    </span>
  );
};
